import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Btn, Modal, Input, Toggle, ListEditor } from "./AdminUI";
import { Plus, Edit2, Trash2 } from "lucide-react";

const EMPTY = { name: "", rate: 1800, unit: "per sq.ft.", specifications: [], active: true, order: 0, popular: false };

export default function PackagesAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/packages/admin/all").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!editing.name.trim()) return alert("Name required");
    const body = { ...editing, rate: parseFloat(editing.rate) };
    if (editing.id) await api.put(`/packages/admin/${editing.id}`, body);
    else await api.post("/packages/admin", body);
    setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete package?")) { await api.delete(`/packages/admin/${id}`); load(); } };
  const setF = (k, v) => setEditing({ ...editing, [k]: v });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-ink">Construction Packages</h1>
        <Btn onClick={() => setEditing({ ...EMPTY })} data-testid="add-package-btn"><Plus size={16} /> Add Package</Btn>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p) => (
          <div key={p.id} className="rounded-xl2 bg-white border border-line p-5">
            <div className="flex items-center justify-between"><h3 className="font-bold text-ink">{p.name}</h3>{p.popular && <span className="text-[10px] bg-gold text-white px-2 py-0.5 rounded-full">POPULAR</span>}</div>
            <div className="text-2xl font-extrabold text-gold mt-1">₹{p.rate} <span className="text-xs text-muted font-normal">{p.unit}</span></div>
            <ul className="mt-3 space-y-1 text-xs text-muted">{p.specifications?.map((s, i) => <li key={i}>· {s}</li>)}</ul>
            {!p.active && <span className="text-[10px] bg-ink/80 text-white px-2 py-0.5 rounded-full mt-2 inline-block">Inactive</span>}
            <div className="flex gap-2 mt-3"><Btn variant="outline" onClick={() => setEditing({ ...EMPTY, ...p })}><Edit2 size={14} /> Edit</Btn><Btn variant="danger" onClick={() => del(p.id)}><Trash2 size={14} /></Btn></div>
          </div>
        ))}
      </div>
      {editing && (
        <Modal title={editing.id ? "Edit Package" : "Add Package"} onClose={() => setEditing(null)}>
          <div className="space-y-4">
            <Input label="Package Name *" value={editing.name} onChange={(v) => setF("name", v)} />
            <div className="grid grid-cols-2 gap-4">
              <Input label="Rate (₹)" type="number" value={editing.rate} onChange={(v) => setF("rate", v)} />
              <Input label="Unit" value={editing.unit} onChange={(v) => setF("unit", v)} />
            </div>
            <ListEditor label="Specifications" items={editing.specifications} onChange={(v) => setF("specifications", v)} />
            <div className="grid grid-cols-2 gap-3">
              <Toggle label="Active" checked={editing.active} onChange={(v) => setF("active", v)} />
              <Toggle label="Popular" checked={editing.popular} onChange={(v) => setF("popular", v)} />
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-6"><Btn variant="outline" onClick={() => setEditing(null)}>Cancel</Btn><Btn onClick={save} data-testid="save-package-btn">Save</Btn></div>
        </Modal>
      )}
    </div>
  );
}
